import { ReactNode } from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type NotificationSeverity = 'error' | 'info' | 'success' | 'warning';

type Notification = {
  id?: string;
  title?: string;
  message: ReactNode;
  severity: NotificationSeverity;
};

interface NotificationsState {
  currentNotification?: Notification;
}

const initialState: NotificationsState = {
  currentNotification: undefined,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setCurrentNotification: (
      state,
      action: PayloadAction<Notification | undefined>,
    ) => {
      if (action.payload && !action.payload.id) {
        action.payload.id = Math.random().toString();
      }
      state.currentNotification = action.payload;
    },
  },
});

export const selectCurrentNotification = (state: RootState) =>
  state.notifications.currentNotification;

export default notificationsSlice.reducer;
